<template>
  <div
    class="flex flex-col md:flex-row md:justify-between w-full relative rounded-t-sm"
    :class="{
      'p-4 bg-primary border-b border-secondary': divider,
      'px-4 pt-4': !divider,
      'rounded-t-sm': rounded === 'sm',
      'rounded-t-md': rounded === 'md',
      'rounded-t-lg': rounded === 'lg',
      'rounded-t-xl': rounded === 'xl',
    }"
  >
    <div class="flex flex-row gap-4 md:gap-2">
      <slot name="start">
        <Avatar
          v-if="avatar"
          :src="avatar.src"
          :name="avatar.name"
          :initials="avatar.initials"
          :size="maxSmall ? 'xl' : '2xl'"
          :shape="avatar.shape"
        />
      </slot>
      <div class="flex flex-col mb-4 md:pb-0 grow gap-1">
        <div class="flex items-center gap-2 text-balance grow">
          <span
            class="md:text-style-xl text-style-lg font-semibold items-center"
          >
            {{ title }}
          </span>
          <Badge
            v-if="badge"
            :label="badge"
            variant="pill"
            type="color"
            color="brand"
            size="sm"
            class="ltr:ml-2 rtl:mr-2"
          />
        </div>
        <span class="text-tertiary text-style-sm font-regular">
          {{ subtitle }}
        </span>
      </div>
    </div>
    <div class="flex flex-row gap-3 shrink-0 items-center">
      <slot name="end" />
      <div
        v-if="$slots.dropdown"
        class="absolute md:relative md:flex right-4 top-5 md:top-0 md:right-0"
      >
        <slot name="dropdown" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { Avatar } from "@/SharedComponents/Avatars";
import { Badge } from "@/SharedComponents/Badges";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();
defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: false,
  },
  badge: {
    type: String,
    default: null,
  },
  avatar: {
    type: Object,
    required: false,
  },
  divider: {
    type: Boolean,
    default: true,
  },
  rounded: {
    type: String,
    default: "sm",
  },
});
</script>
